"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFirstHiddenTime;

var _page = require("../page");

var _pageVisibility = require("./pageVisibility");

var hidden = (0, _pageVisibility.getHiddenPropName)(); // Keep track of whether (and when) the page was first hidden, see:
// https://github.com/w3c/page-visibility/issues/29
// NOTE: ideally this check would be performed in the document head
// to avoid cases where the visibility state changes before this code runs.

var firstHiddenTime = hidden != null && document[hidden] ? 0 : Infinity;
(0, _page.addPageDelegate)({
  pageDidDisappear: function pageDidDisappear(event) {
    firstHiddenTime = Math.min(firstHiddenTime, event.timeStamp);
  }
});

function getFirstHiddenTime() {
  return firstHiddenTime;
}